export default function Footer() {
  return (
    <div
      className="w-full mt-5 flex justify-between p-4 pl-2 pr-2 bg-white  text-xs "
      style={{ boxShadow: "3px 0px 4px 0px #999999" }}
    >
      <span>
       <a href="https://dantaniinc.com/">Datani Sports home </a> | <a href="https://dantaniinc.com/terms">Term of Service </a>| <a href="https://dantaniinc.com/privacy">Privacy Policy</a> 
      </span>
      <span>© {new Date().getFullYear()} Dantani Sports</span>
    </div>
  );
}
